import {
  Companion_getInstance3mwnn7es55j4h as Companion_getInstance,
  FiledForArbitrationrkri4vx0h6kh as FiledForArbitration,
  AccessInfoj60d6hx1qs8r as AccessInfo,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareFiledForArbitrationFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [FiledForArbitration_accessInfo_getInstance(), FiledForArbitration_evidence_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function FiledForArbitration_accessInfo$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function FiledForArbitration_accessInfo$_get_name_$ref_fj3ulc() {
  return (p0) => p0.i20();
}
function FiledForArbitration_accessInfo$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FiledForArbitration_accessInfo$_get_serializer_$ref_syp2x() {
  return (p0) => p0.h2j();
}
function FiledForArbitration_accessInfo$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function FiledForArbitration_accessInfo$_get_annotations_$ref_8u6izv() {
  return (p0) => p0.bz();
}
var FiledForArbitration_accessInfoClass;
function FiledForArbitration_accessInfo() {
  if (FiledForArbitration_accessInfoClass === VOID) {
    class $ {
      constructor() {
        FiledForArbitration_accessInfo_instance = this;
        var tmp = this;
        tmp.m60_1 = lazy(FiledForArbitration_accessInfo$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n60_1 = lazy(FiledForArbitration_accessInfo$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o60_1 = lazy(FiledForArbitration_accessInfo$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.m60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FiledForArbitration_accessInfo$_get_name_$ref_fj3ulc(), null);
        return tmp0.f2();
      }
      p60(receiver) {
        return receiver.q60_1;
      }
      k2j(receiver) {
        return this.p60(receiver instanceof FiledForArbitration() ? receiver : THROW_CCE());
      }
      s60(receiver, value) {
        return receiver.t60(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FiledForArbitration() ? receiver : THROW_CCE();
        return this.s60(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FiledForArbitration_accessInfo$_get_serializer_$ref_syp2x(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FiledForArbitration_accessInfo$_get_annotations_$ref_8u6izv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FiledForArbitration_accessInfo', VOID, VOID, [SerializableProperty()]);
    FiledForArbitration_accessInfoClass = $;
  }
  return FiledForArbitration_accessInfoClass;
}
var FiledForArbitration_accessInfo_instance;
function FiledForArbitration_accessInfo_getInstance() {
  if (FiledForArbitration_accessInfo_instance === VOID)
    new (FiledForArbitration_accessInfo())();
  return FiledForArbitration_accessInfo_instance;
}
function FiledForArbitration_evidence$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function FiledForArbitration_evidence$_get_name_$ref_pdqaaj() {
  return (p0) => p0.i20();
}
function FiledForArbitration_evidence$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FiledForArbitration_evidence$_get_serializer_$ref_7tvzd8() {
  return (p0) => p0.h2j();
}
function FiledForArbitration_evidence$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function FiledForArbitration_evidence$_get_annotations_$ref_pa7p00() {
  return (p0) => p0.bz();
}
var FiledForArbitration_evidenceClass;
function FiledForArbitration_evidence() {
  if (FiledForArbitration_evidenceClass === VOID) {
    class $ {
      constructor() {
        FiledForArbitration_evidence_instance = this;
        var tmp = this;
        tmp.u60_1 = lazy(FiledForArbitration_evidence$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v60_1 = lazy(FiledForArbitration_evidence$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w60_1 = lazy(FiledForArbitration_evidence$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.u60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FiledForArbitration_evidence$_get_name_$ref_pdqaaj(), null);
        return tmp0.f2();
      }
      p60(receiver) {
        return receiver.r60_1;
      }
      k2j(receiver) {
        return this.p60(receiver instanceof FiledForArbitration() ? receiver : THROW_CCE());
      }
      x60(receiver, value) {
        return receiver.t60(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof FiledForArbitration() ? receiver : THROW_CCE();
        return this.x60(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.v60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FiledForArbitration_evidence$_get_serializer_$ref_7tvzd8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w60_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FiledForArbitration_evidence$_get_annotations_$ref_pa7p00(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'FiledForArbitration_evidence', VOID, VOID, [SerializableProperty()]);
    FiledForArbitration_evidenceClass = $;
  }
  return FiledForArbitration_evidenceClass;
}
var FiledForArbitration_evidence_instance;
function FiledForArbitration_evidence_getInstance() {
  if (FiledForArbitration_evidence_instance === VOID)
    new (FiledForArbitration_evidence())();
  return FiledForArbitration_evidence_instance;
}
//region block: exports
export {
  prepareFiledForArbitrationFields as prepareFiledForArbitrationFields1j86gdxivz92e,
};
//endregion

//# sourceMappingURL=FiledForArbitrationFields.mjs.map
